import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_sku_platform_queryList": "/product/sku/platform/queryList",
    "api_add_sku_platform": "/product/sku/platform/add",
    "api_update_sku_platform": "/product/sku/platform/update",
    "api_delete_sku_platform": "/product/sku/platform/delete",
    "api_sku_all": "/product/sku/queryAll",
    "api_sku_queryList": "/product/sku/queryList", // 查询SKU

}

// initial state
const state = {
    skuPLatformList: {},
    skuAll: [],
    skuList: {}
}

// getters
const getters = {
    getSKUPlatformList: state => {
        return state.skuPLatformList
    },
    getSKUAll: state => {
        return state.skuAll
    },
    getSKUList: state => {
        return state.skuList
    },
}

// actions
const actions = {
    getSKUList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_sku_queryList,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('SKU_LIST', res || {});
            } else {
                commit('SKU_LIST', {});
            }
        }).catch(err => {
            commit('SKU_LIST', {});
        })
    },
    getSKUPlatformList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_sku_platform_queryList,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('SKU_PLATFORM_LIST', res || {});
            } else {
                commit('SKU_PLATFORM_LIST', {});
            }
        }).catch(err => {
            commit('SKU_PLATFORM_LIST', {});
        })
    },
    addSKUPlatform: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_add_sku_platform,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    updateSKUPlatform: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_update_sku_platform,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    deleteSKUPlatform: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_delete_sku_platform,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    getSKUAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_sku_all,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('SKU_ALL', res.data || []);
            } else {
                commit('SKU_ALL', []);
            }
        }).catch(err => {
            commit('SKU_ALL', []);
        })
    },
}


// mutations
const mutations = {
    SKU_PLATFORM_LIST: (state, pageData) => {
        state.skuPLatformList = pageData;
    },
    SKU_LIST: (state, pageData) => {
        state.skuList = pageData;
    },
    SKU_ALL: (state, pageData) => {
        state.skuAll = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stageInfo.js